import React from 'react';
import { Component } from '@poa/core';

import PaymentStaff from '../../staff/payment-staff';

class ProfileTabRequisites extends React.Component {
  store;
  actions; // injected by Poa
  t;

  componentDidMount() {
    // console.log('this.props.state.model', this.props.state.model);
  }

  render() {
    return (
      <div className="tab-payment tab active" data-tab="questionnaire">
        <div className="tab__inner" style={{ display: 'flex', justifyContent: 'center' }}>
          <div className="main-form">
            <form
              name="auth_form"
              onSubmit={this.handleAuthFormSubmit}
              ref={node => (this.form = node)}
            >
              <div className="form-payment">
                <PaymentStaff
                  data={this.props.state.model}
                  userId={this.props.state.model.id}
                  disabledButton={true}
                  onChangeData={data => {
                    const initialData = this.props.state.model;
                    this.props.state.model = {
                      ...initialData,
                      ...data
                    };
                  }}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Component({ namespaces: ['profile-tab-requisites'] })(ProfileTabRequisites);
